module.exports = __webpack_public_path__ + "static/img/tu_jkfa_icon.png";